import React from 'react';

const LabelContainer: React.FC<any> = (props) => {
  const { property } = props;

  return (
    <>
      <div
        className="label"
        style={{
          margin: property.margin,
          padding: property.padding,
          textAlign: property.align,
          fontWeight: property.fontWeight,
          fontSize: property.fontSize,
          color: property.fontColor,
        }}
      >
        {property.label}
      </div>
    </>
  );
};

export default LabelContainer;
